<template>
  <section :class="['ss-sku-wrapper', displayModeClassName, getClassName]">
    <div class="title" :style="mFontColor" v-html="skuTitle"></div>
    <div class="ss-content">
      <div :class="['sku-detail-wrapper', getClassName]">
        <template v-if="filterCurrencySkus && filterCurrencySkus.length > 0">
          <div class="sku-details">
            <img class="sku-desc-icon" :src="skuItems.skuUrl" />
            <div class="discount-img">{{ skuItems.discount }}%</div>
            <div class="discount-wrapper" v-if="skuItems.name && skuItems.gold">
              <div class="dicount-basic-bar">
                <span class="discount-infos">
                  <img
                    class="dicount-icon"
                    :src="skuItems.icon"
                    v-if="skuItems.icon"
                  />
                  <span class="dicount-name" v-if="skuItems.name">{{
                    skuItems.name
                  }}</span>
                </span>
                <span class="dicount-amount" v-if="skuItems.gold"
                  >x{{ skuItems.gold }}</span
                >
              </div>
            </div>
            <ul
              class="sku-items-wrapper"
              v-if="skuItems && skuItems.items && skuItems.items.length > 0"
            >
              <li
                class="sku-items"
                v-for="(item, index) in skuItems.items"
                :key="index"
              >
                <div class="sku-item-desc">
                  <img class="sku-item-icon" :src="item.itemUrl" />
                  <p class="sku-item-name">{{ item.itemName }}</p>
                </div>
                <p class="sku-item-amount">x{{ item.itemAmount }}</p>
              </li>
            </ul>
            <div class="sku-bottom-wrapper">
              <p class="time">
                <img
                  :src="
                    require(`@/assets/images/detail/state-of-survival/clock.png`)
                  "
                  class="clock-icon"
                />
                <van-count-down :time="getEndTime" format="DD d HH:mm:ss" />
              </p>
              <button @click="gotoDetail">
                {{ $t('state-of-survival.detail') }}
              </button>
              <!-- <p class="desc">{{ skuItems.skuName }}</p> -->
            </div>
          </div>
        </template>
        <template v-else>
          <div class="sku-placehoder-wrapper">
            <div class="locked-wrapper">
              <img
                class="locked-icon"
                :src="
                  require(`@/assets/images/detail/state-of-survival/locked.png`)
                "
              />
              <img
                class="locked-icon"
                :src="
                  require(`@/assets/images/detail/state-of-survival/locked.png`)
                "
              />
              <img
                class="locked-icon"
                :src="
                  require(`@/assets/images/detail/state-of-survival/locked.png`)
                "
              />
            </div>
            <div class="sku-placeholder-tips">
              {{ $t('state-of-survival.locked_tips') }}
            </div>
          </div>
        </template>
      </div>
      <ul
        class="sku-detail-info"
        v-if="filterCurrencySkus && filterCurrencySkus.length > 0"
      >
        <li class="title">{{ $t('state-of-survival.choose_sku_tips') }}</li>
        <li
          v-for="item in filterCurrencySkus"
          :key="item.skuId"
          @click="skuClick(item)"
          :class="['sku-detail-item', activeId === item.skuId ? 'active' : '']"
        >
          <p class="infos">
            {{ item.skuName }}
          </p>
        </li>
      </ul>

      <van-popup
        v-model="showDetail"
        catch:touchstart
        get-container=".sku-detail-wrapper"
        v-if="skuItems && skuItems.items && skuItems.items.length > 0"
      >
        <div class="detail-body">
          <p class="title">{{ $t('state-of-survival.detail') }}</p>
          <ul
            class="sku-items-wrapper"
            v-if="skuItems && skuItems.items && skuItems.items.length > 0"
          >
            <li
              class="sku-items"
              v-for="(item, index) in skuItems.items"
              :key="index"
            >
              <div class="sku-item-desc">
                <img class="sku-item-icon" :src="item.itemUrl" />
                <p class="sku-item-name">{{ item.itemName }}</p>
              </div>
              <p class="sku-item-amount">x{{ item.itemAmount }}</p>
            </li>
          </ul>
        </div>
        <div class="btn-wrapper">
          <button class="close-btn" @click="closePopup">
            {{ $t('common.gotIt') }}
          </button>
        </div>
      </van-popup>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  export default {
    name: 'oldStateOfSurvival',
    mixins: [styleConfiguration],
    data() {
      return {
        showDetail: false,
        activeId: '',
      }
    },
    computed: {
      ...mapGetters(['displayModeClassName']),
      ...mapGetters('detail', ['filterCurrencySkus']),
      skuItems() {
        const skulist = this.filterCurrencySkus
        if (skulist && skulist.length) {
          return skulist.find((item) => item.skuId === this.activeId) || {}
        }
        return {}
      },

      getEndTime() {
        return this.skuItems.endTime * 1000 - new Date().getTime()
      },

      getClassName() {
        return this.filterCurrencySkus && this.filterCurrencySkus.length > 0
          ? 'column_display'
          : 'block_display'
      },
      skuTitle() {
        const skuTitle = this.$t(`publicDetails.sku_title`)
        return `2. ${skuTitle}`
      },
    },
    watch: {
      filterCurrencySkus: {
        handler(newVal) {
          if (newVal && newVal.length) {
            // 默认选中第一个
            this.skuClick(newVal[0])
          }
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      ...mapMutations(['detail/setCheckSkuItem', 'detail/setChekOuterSkuItem']),
      skuClick(item) {
        this.activeId = item.skuId
        this['detail/setCheckSkuItem'](item)

        // 下单的时候 使用
        const _item = JSON.stringify(item)
        this['detail/setChekOuterSkuItem'](_item)
      },
      closePopup() {
        this.showDetail = false
      },
      gotoDetail() {
        this.showDetail = true
      },
    },
    mounted() {},
  }
</script>

<style lang="scss" src="./style.scss" scoped></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './style_pc.scss';
  }
</style>
